import Client from 'modules/Client'

export default {
  inviteFriend (data) {
    return Client.post('api/aluno/indicacao', { data })
      .then(data => data || true)
  }
}
